import { ThunkAction } from 'redux-thunk'
import store, { RootState } from '..'
import { expenseApi } from '../../apis'
import { ExpenseEntity, ExpenseFilter } from '../../models'
import {
  ExpenseAction,
  SET_EXPENSES,
  SET_EXPENSES_LOADED,
  SET_EXPENSE_FILTER,
  SET_TOTAL_EXPENSES,
} from '../types'
import { loadProfile } from './authAction'

export const setExpenses = (expenses: ExpenseEntity[]): ExpenseAction => ({
  type: SET_EXPENSES,
  payload: expenses,
})

export const setTotalExpenses = (total: number): ExpenseAction => ({
  type: SET_TOTAL_EXPENSES,
  payload: total,
})

export const setExpensesLoaded = (loaded: boolean): ExpenseAction => ({
  type: SET_EXPENSES_LOADED,
  payload: loaded,
})

export const setExpenseFilter = (filter: ExpenseFilter): ExpenseAction => ({
  type: SET_EXPENSE_FILTER,
  payload: {
    ...filter,
    createdDateFrom: filter.createdDateFrom
      ? new Date(
          new Date(filter.createdDateFrom).setHours(0, 0, 0, 0)
        ).getTime()
      : undefined,
    createdDateTo: filter.createdDateTo
      ? new Date(
          new Date(filter.createdDateTo).setHours(23, 59, 59, 999)
        ).getTime()
      : undefined,
  },
})

export const loadExpenses = (): ThunkAction<
  void,
  RootState,
  null,
  ExpenseAction
> => {
  return async (dispatch) => {
    try {
      dispatch(setExpensesLoaded(false))
      const resp = await expenseApi.getExpenses(
        store.getState().expense.expenseFilter
      )
      dispatch(setExpenses(resp.data.data))
      dispatch(setTotalExpenses(resp.data.totalElement))
    } catch (e) {
      if (e && e.response && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await expenseApi.getExpenses(
          store.getState().expense.expenseFilter
        )
        dispatch(setExpenses(resp.data.data))
        dispatch(setTotalExpenses(resp.data.totalElement))
      }
    } finally {
      dispatch(setExpensesLoaded(true))
    }
  }
}
